'use client';
import { GppGoodOutlined } from '@mui/icons-material';
import { PlanUpgradeBackground } from '@practium/ui';
import styles from './ProfileInfoCard.module.css';

export const ProfileInfoCard = () => {
	return (
		<div className={styles.infoCard}>
			<PlanUpgradeBackground className={styles.svgBackground} />

			<div className={styles.content}>
				<div className={styles.badge}>
					<GppGoodOutlined className={styles.badgeIcon} />
					<span className={styles.badgeText}>Segurança</span>
				</div>

				<h3 className={styles.title}>Proteção de Dados</h3>

				<p className={styles.description}>
					O Practium opera em total
					conformidade com a LGPD para garantir a proteção dos seus dados pessoais e agrícolas.
				</p>

			</div>
		</div>
	);
};
